import { PricingModelProvider } from './PricingModel.context';
import PricingModelView from './PricingModel.view';

import type { ProviderProps } from './pricingModel.types';

type Props = ProviderProps & {
  id: string;
};

function PricingModel({ id, ...otherProps }: Props) {
  return (
    <PricingModelProvider {...otherProps}>
      <PricingModelView id={id} />
    </PricingModelProvider>
  );
}

export default PricingModel;
